import React from "react";
import "./Shadow.scss";

interface IProps {
    position: 'wall' | 'floor' | 'floor-faded';
}

export function Shadow({ position }: IProps) {
    return (
        <div className={`shadow ${position}`} />
    )
}
